export const dublinCoordinates = {
  latitude: 53.35000220148259,
  longitude: -6.260000000000002,
};
